import { PlatformShell } from '../components/layout/PlatformShell'
import { HowWeWorkHero } from '../components/sections/how-we-work/HowWeWorkHero'
import { HowWeWorkPhases } from '../components/sections/how-we-work/HowWeWorkPhases'
import { HowWeWorkInstalled } from '../components/sections/how-we-work/HowWeWorkInstalled'
import { HowWeWorkCommercial } from '../components/sections/how-we-work/HowWeWorkCommercial'
import { HowWeWorkContinue } from '../components/sections/how-we-work/HowWeWorkContinue'
import { HowWeWorkCTA } from '../components/sections/how-we-work/HowWeWorkCTA'

export function HowWeWorkPage() {
  return (
    <PlatformShell>
      <HowWeWorkHero />
      <HowWeWorkPhases />
      <HowWeWorkInstalled />
      <HowWeWorkCommercial />
      <HowWeWorkContinue />
      <HowWeWorkCTA />
    </PlatformShell>
  )
}
